import { Button, Col } from "antd";
import ReactQuill from "react-quill";
import styled from "styled-components";

export const StyledMainCol = styled(Col)`
  height: 83.5vh;
  background: whitesmoke;
  margin-top: 50px;
  margin-bottom: 40px;
  overflow-y: auto;
  /* Hide scrollbar for Chrome, Safari, and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for Firefox */
  scrollbar-width: none;
  /* Hide scrollbar for IE and Edge */
  -ms-overflow-style: none;
`;

export const StyledQuill = styled(ReactQuill)`
  color: #2c3e50;
  height: 70vh;
  max-height: 70vh;
  font-size: 16px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  max-width: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid #e1e8ed;
  margin-top: 10px;
  
  .ql-toolbar.ql-snow + .ql-container.ql-snow .ql-footer {
    display: none;
  }

  & .ql-toolbar {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border: none;
    border-bottom: 1px solid #e2e8f0;
    padding: 12px 16px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    
    .ql-picker-label,
    .ql-picker-item {
      color: #475569;
      font-weight: 500;
    }
    
    .ql-picker-label:hover,
    .ql-picker-item:hover {
      color: #005461;
    }
    
    .ql-picker.ql-expanded .ql-picker-label {
      color: #005461;
    }
    
    .ql-picker-options {
      background: white;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
    
    .ql-picker-item {
      padding: 8px 12px;
      border-radius: 4px;
      margin: 2px 4px;
    }
    
    .ql-picker-item:hover {
      background: #f1f5f9;
    }
    
    .ql-picker-item.ql-selected {
      background: #005461;
      color: white;
    }
  }

  & .ql-container {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif !important;
    border: none !important;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    background: white;
  }

  & .ql-editor {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif !important;
    font-size: 16px;
    line-height: 1.6;
    color: #2c3e50;
    padding: 24px;
    min-height: 300px;
    max-height: calc(70vh - 60px);
    overflow-y: auto;
    scrollbar-width: thin;
    
    &::-webkit-scrollbar {
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f8fafc;
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: linear-gradient(135deg, #cbd5e1, #94a3b8);
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
      background: linear-gradient(135deg, #94a3b8, #64748b);
    }
    
    h1, h2, h3, h4, h5, h6 {
      color: #1e293b;
      font-weight: 600;
      margin: 24px 0 16px 0;
    }
    
    h1 {
      font-size: 28px;
      border-bottom: 2px solid #e2e8f0;
      padding-bottom: 8px;
    }
    
    h2 {
      font-size: 24px;
    }
    
    h3 {
      font-size: 20px;
    }
    
    p {
      margin: 0 0 16px 0;
      color: #475569;
    }
    
    ul, ol {
      margin: 16px 0;
      padding-left: 24px;
    }
    
    li {
      margin: 8px 0;
      color: #475569;
    }
    
    blockquote {
      border-left: 4px solid #005461;
      background: #f8fafc;
      margin: 16px 0;
      padding: 16px 20px;
      border-radius: 0 8px 8px 0;
      font-style: italic;
      color: #64748b;
    }
    
    a {
      color: #005461;
      text-decoration: none;
      border-bottom: 1px solid transparent;
      transition: all 0.2s ease;
    }
    
    a:hover {
      border-bottom-color: #005461;
    }
    
    strong {
      font-weight: 600;
      color: #1e293b;
    }
    
    em {
      font-style: italic;
      color: #64748b;
    }
  }

  /* Toolbar button styling */
  & .ql-toolbar .ql-stroke {
    stroke: #64748b;
  }
  
  & .ql-toolbar .ql-fill {
    fill: #64748b;
  }
  
  & .ql-toolbar button {
    border-radius: 6px;
    margin: 0 2px;
    padding: 6px;
    transition: all 0.2s ease;
    
    &:hover {
      background: #e2e8f0;
      
      .ql-stroke {
        stroke: #005461;
      }
      
      .ql-fill {
        fill: #005461;
      }
    }
    
    &.ql-active {
      background: #005461;
      
      .ql-stroke {
        stroke: white;
      }
      
      .ql-fill {
        fill: white;
      }
    }
  }
  
  & .ql-toolbar .ql-picker {
    border-radius: 6px;
    margin: 0 2px;
    
    &:hover {
      background: #e2e8f0;
    }
  }

  @media (max-width: 1366px) {
    height: 60vh;
    max-height: 60vh;
    
    & .ql-editor {
      max-height: calc(60vh - 60px);
    }
  }
  
  @media (max-width: 768px) {
    height: 50vh;
    max-height: 50vh;
    
    & .ql-editor {
      padding: 16px;
      font-size: 14px;
      max-height: calc(50vh - 60px);
    }
  }

  /* RTL support for blockquotes */
  .ql-editor[dir="rtl"] blockquote {
    border-left: none;
    border-right: 4px solid #005461;
    padding-left: 0;
    padding-right: 20px;
    text-align: right;
  }

  /* RTL support for lists */
  .ql-editor[dir="rtl"] ul,
  .ql-editor[dir="rtl"] ol {
    padding-left: 0;
    padding-right: 24px;
  }
  
  /* Font picker styling */
  & .ql-picker.ql-font .ql-picker-label[data-value="Arial"]::before,
  & .ql-picker.ql-font .ql-picker-item[data-value="Arial"]::before {
    font-family: "Arial", sans-serif;
    content: "Arial";
  }
  
  & .ql-picker.ql-font .ql-picker-label[data-value="Times New Roman"]::before,
  & .ql-picker.ql-font .ql-picker-item[data-value="Times New Roman"]::before {
    font-family: "Times New Roman", serif;
    content: "Times New Roman";
  }
  
  & .ql-picker.ql-font .ql-picker-label[data-value="Courier New"]::before,
  & .ql-picker.ql-font .ql-picker-item[data-value="Courier New"]::before {
    font-family: "Courier New", monospace;
    content: "Courier New";
  }
  
  /* Set content font-families */
  & .ql-font-Arial {
    font-family: "Arial", sans-serif;
  }
  
  & .ql-font-Times-New-Roman {
    font-family: "Times New Roman", serif;
  }
  
  & .ql-font-Courier-New {
    font-family: "Courier New", monospace;
  }
`;

export const StyledPrimaryBackButton = styled(Button)`
  &&.ant-btn-primary {
    background-color: white;

    font-size: 16px;
    width: 30%;
    height: 45px;
    margin-top: 10px;
    margin-bottom: 25px;
    border-radius: 50px;
    border-color: black;
    color: black;
    /* border-radius: 0px; */
    font-family: "Lato";

    &:hover {
      background-color: black;
      border-color: black;

      color: white;
    }
    &:disabled {
      background-color: lightgray;
      border-color: lightgray;
      color: white;
    }
  }
`;

export const StyledPrimaryButton = styled(Button)`
  &&.ant-btn-primary {
    background-color: #b80000;
    font-size: 16px;
    width: 34%;
    height: 45px;
    margin-top: 10px;
    margin-bottom: 25px;
    border-radius: 50px;
    border-color: #b80000;
    color: white;
    /* border-radius: 0px; */
    font-family: "Lato";

    &:hover {
      background-color: white;
      border-color: #b80000;

      color: #b80000;
    }
    &:disabled {
      background-color: lightgray;
      border-color: lightgray;
      color: white;
    }
  }
`;
export const StyledDownloadButton = styled(Button)`
  &&.ant-btn-primary {
    font-family: Lato;
    font-size: 16px;
    width: 160px;
    padding: 20px;
    border-radius: 49px;
    line-height: 15px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #005461;
    border-color: #005461;
    color: white;
    font-family: "Lato";

    &:hover {
      background-color: white;
      border-color: #005461;
      color: #005461;
    }
    &:disabled {
      background-color: lightgray;
      border-color: lightgray;
      color: white;
    }
  }
`;

